var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Box, Typography } from '@mui/material';
var INTERNSHIP_STRINGS = appStrings.modules.nugget.internship;
export function NuggetInternshipSmall(_a) {
    var variant = _a.variant, _b = _a.contentSize, contentSize = _b === void 0 ? 'LARGE' : _b;
    var _c = useState(false), isLogoLinkValid = _c[0], setIsLogoLinkValid = _c[1];
    var titleStyles = contentSize === 'SMALL' ? smallTextStyle : textStyle;
    return (_jsxs(Box, { sx: containerStyle, children: [_jsxs(Box, { sx: textWrapperStyle, children: [variant.internshipInfo.role_type && (_jsxs(Typography, { variant: "body1", sx: titleStyles, children: [_jsx("em", { children: INTERNSHIP_STRINGS.QUICK_LOOK.type }), " ", variant.internshipInfo.role_type] })), variant.internshipInfo.career_path_name && (_jsxs(Typography, { variant: "body1", sx: titleStyles, children: [_jsx("em", { children: INTERNSHIP_STRINGS.QUICK_LOOK.path }), " ", variant.internshipInfo.career_path_name] })), variant.internshipInfo.location && (_jsxs(Typography, { variant: "body1", sx: titleStyles, children: [_jsx("em", { children: INTERNSHIP_STRINGS.QUICK_LOOK.location }), " ", variant.internshipInfo.location] })), variant.internshipInfo.apply_by_date && (_jsxs(Typography, { variant: "body1", sx: titleStyles, children: [_jsx("em", { children: INTERNSHIP_STRINGS.QUICK_LOOK.deadline }), ' ', new Date(variant.internshipInfo.apply_by_date).toLocaleDateString()] }))] }), variant.internshipInfo.logo_link && (_jsx(Box, { component: "img", src: variant.internshipInfo.logo_link, alt: "Internship", sx: __assign(__assign({}, logoImageStyle), { display: isLogoLinkValid ? 'block' : 'none' }), onLoad: function () { return setIsLogoLinkValid(true); }, onError: function () { return setIsLogoLinkValid(false); } }))] }));
}
var textStyle = {
    fontFamily: 'Sarabun',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '20px',
    mt: 1,
    textOverflow: 'ellipsis',
    display: 'block',
};
var textWrapperStyle = {
    flex: 1,
    minWidth: 0,
};
var smallTextStyle = {
    fontFamily: 'Sarabun',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '18px',
    mt: 0.5,
};
var containerStyle = {
    mt: 2,
    flexDirection: { xs: 'row', sm: 'column', md: 'row' },
    display: 'flex',
    justifyContent: 'space-between',
};
var logoImageStyle = {
    maxWidth: '83px',
    minWidth: '83px',
    maxHeight: '83px',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    alignSelf: 'flex-end',
    mt: 2,
    ml: 4,
};
